import axios from 'axios'
import router from '../routes/index'
import {auth} from '../api/api-endpoints'
import {HTTP_TIMEOUT} from '../config/config'
import {API_ACCEPT_LANGUAGE} from "../config/locale"
import Vue from 'vue'

axios.defaults.timeout = HTTP_TIMEOUT
axios.defaults.headers['Accept-Language'] = API_ACCEPT_LANGUAGE
// axios.defaults.headers['Content-Type'] = 'application/json'
axios.interceptors.response.use(function (response) {
  let {config: {store}} = response
  api.checkUserUpdatedHeader(response, store)
  return response
}, function (error) {
  let {config = {}, response} = error
  let errorReport = {config, response}
  let {store, onMutateError} = config
  if (!onMutateError) {
    onMutateError = commitError
  }
  let disableErrorHandler = config.disableGlobalError || false
  let disableAuthErrorHandler = config.disableAuthError || false
  if (config.method !== 'get') {
    disableErrorHandler = true
  }
  if (response) {
    api.checkUserUpdatedHeader(response, store)
    // not autorized
    if (+error.response.status === 401) {
      if (disableAuthErrorHandler === false) {
        errorReport = null
        store.commit('needReLogin', true)
        store.commit('mutateError', error)
      }
      // forbiden
    } else if (+response.status === 403 && config.method === 'get') {
      disableErrorHandler === false && onMutateError({store, config, response, error, commitError})
    } else if (+response.status === 422 && config.method !== 'get') {
      // skip 422 for post
      errorReport = null
    } else {
      disableErrorHandler === false && onMutateError({store, config, response, error, commitError})
    }
  } else if (config && config.method === 'get') {
    disableErrorHandler === false && onMutateError({store, config, response, error, commitError})
  } else {
    disableErrorHandler === false && onMutateError({store, config, response, error, commitError})
  }
  if (errorReport && Vue.prototype.$bugsnagClient) {
    delete errorReport.config.store
    let routeName = getRouterName()
    Vue.prototype.$bugsnagClient.notify({
      name: 'HTTP error on ' + routeName,
      message: error.message,
      fileName: error.fileName,
      lineNumber: error.lineNumber
    }, {
      metaData: errorReport
    })
  }

  // cast json errors if blob type  response
  // we dont use axios.defaults.transformResponse because dont return status
  if (!error.data && error.config && error.config.responseType === 'blob' && error.response && error.response.data) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.addEventListener('loadend', (e) => {
        try {
          error.data = JSON.parse(e.srcElement.result)
        } catch {
          error.data = e.srcElement.result || null
        }
        error.status = error.response.status
        error.statusText = error.response.statusText
        reject(error)
      })
      reader.readAsText(error.response.data)
    })
  } else {
    return Promise.reject(error)
  }
})

function commitError ({store, error}) {
  store.commit('mutateError', error)
}

function getRouterName () {
  let routeName = 'unknown'
  if (router && router.history.pending) {
    routeName = router.history.pending.name
  } else if (router && router.history.current) {
    routeName = router.history.current.name
  }
  return routeName
}

const STATUS_PENDING = 1
const STATUS_COMPLETED = 2
const queuePromises = {}

export default class api{

  static checkUserUpdatedHeader (response, store) {
    if (response && response.headers && response.headers && response.headers['user-updated'] && store?.getters.isGuest === false) {
      const headerUserUpdated = +response.headers['user-updated']
      const {userUpdated = 0} = store.getters.userData
      if (userUpdated < headerUserUpdated) {
        store.dispatch('updateUserData')
      }
    }
  }

  static options (token, params, store) {
    let options = {}
    if (token) {
      options.headers = {
        'Authorization': 'Bearer  ' + token
      }
    }
    if (params) {
      options = {
        ...options,
        ...params
      }
    }
    options.store = store
    return options
  }

  static login (login, password, store) {
    return axios.post(
      auth.login(),
      {LoginForm: {username: login, password: password}},
      {store}
    )
  }

  static get (token, url, options = {}, store) {
    let task = queuePromises[url] || {url}
    if (task.status === STATUS_PENDING) {
      task.counter = task.counter + 1
      console.warn('Double get data check that', task)
      return task.promise
    }
    queuePromises[url] = task
    task.status = STATUS_PENDING
    task.counter = 1
    task.promise = new Promise((resolve, reject) => {
      axios.get(url, api.options(token, options, store)).then(r => {
        task.status = STATUS_COMPLETED
        if (r.config && r.config.afterResponseAPI) {
          r.config.afterResponseAPI()
          resolve(r)
        } else {
          resolve(r)
        }
      }).catch(e => {
        task.status = STATUS_COMPLETED
        if (e.config && e.config.afterResponseAPI) {
          e.config.afterResponseAPI()
          reject(e)
        } else {
          reject(e)
        }
      })
    })
    return task.promise
  }

  static post (token, url, data, options = {}, store) {
    return axios.post(url, data, api.options(token, options, store))
  }

  static saveModel (token, url, data, options = {}, store) {
    return axios.post(url, data, api.options(token, options, store))
  }

  static updateModel (token, url, data, options = {}, store) {
    return axios.patch(url, data, api.options(token, options, store))
  }

  static deleteModel (token, url, options = {}, store) {
    return axios.delete(url, api.options(token, options, store))
  }
}
